export class MessageStrategy {
  send(message, sendMessage) {
    throw new Error("Método 'send' deve ser implementado.")
  }
}